<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  .invite-view {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(12px);
    padding-bottom: utils.in_rem(32px);
    position: relative;
    gap: utils.in_rem(20px);

    .duration-container {
      align-items: center;
      display: flex;
      justify-content: center;
    }

    .title {
      @include mixins.h4;
      color: colors.get(textWhite);
      white-space: nowrap;
      text-align: center;
    }

    .subtitle {
      @include mixins.body3;
      color: colors.get(interfaceTransparentWhite_70);
      text-align: center;
      line-height: 1.2;
    }

    .spacer {
      flex: 1;
    }

    .action-buttons {
      display: flex;
      gap: utils.in_rem(48px);
      justify-content: center;

      :global(.icon-button) {
        padding: utils.in_rem(16px) !important;
        border-radius: utils.in_rem(16px) !important;
      }

      .button-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: utils.in_rem(8px);

        .button-text {
          @include mixins.body3;
          color: colors.get(textWhite);
          text-align: center;
          line-height: 1.2;
        }
      }
    }
  }
</style>

<script>
  import { userStore } from "../../../../api-stores/user-store";
  import { diallerParticipants } from "@sourcewhale/api";
  import { attendeesState } from "../attendeesState.svelte";
  import ConferenceCall from "../components/ConferenceCall.svelte";
  import DiallerCallDuration from "../components/DiallerCallDuration.svelte";
  import KeypadActionButton from "../components/KeypadActionButton.svelte";
  import { diallerState } from "../diallerState.svelte";

  const callAttendees = $derived.by(() => [
    { ...attendeesState.user },
    { ...attendeesState.candidate },
  ]);

  const handleDecline = async () => {
    const user = await userStore.once();
    const callId = diallerState.callId;

    diallerState.closeDialler();

    await diallerParticipants({
      action: "invite",
      callId: callId,
      inviteStatus: "declined",
      invitedUserId: user.userId,
    });
  };

  const handleAccept = async () => {
    const user = await userStore.once();

    const teammate = {
      id: user.userId,
      name: user.name,
      avatar: user.picture,
      role: "teammate",
    };

    diallerState.joinConference(
      diallerState.conferenceId,
      [...callAttendees, teammate],
      "teammate",
    );

    await diallerParticipants({
      action: "invite",
      callId: diallerState.callId,
      inviteStatus: "accepted",
      invitedUserId: user.userId,
    });
  };

  const userName = $derived(attendeesState?.user?.name?.split(" ")[0]);
  const candidateName = $derived(
    attendeesState?.candidate?.name?.split(" ")[0],
  );
  const subtitle = $derived(
    `${userName} has invited you to join a call with ${candidateName}`,
  );
</script>

<div class="invite-view">
  <div class="duration-container">
    <DiallerCallDuration visible={true} />
  </div>
  <div class="title">Incoming call</div>

  <div class="subtitle">
    {subtitle}
  </div>

  <ConferenceCall />

  <div class="spacer"></div>

  <div class="action-buttons">
    <div class="button-container">
      <KeypadActionButton
        onClick={handleDecline}
        rotation={135}
        type="decline"
      />
      <div class="button-text">Decline</div>
    </div>
    <div class="button-container">
      <KeypadActionButton onClick={handleAccept} type="accept" />
      <div class="button-text">Accept</div>
    </div>
  </div>
</div>
